import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sub_page_con wrap_1120" }
const _hoisted_2 = { class: "total_num" }
const _hoisted_3 = { class: "total_num_value" }
const _hoisted_4 = {
  key: 0,
  class: "btn_wrap _default right_btn _board_type"
}
const _hoisted_5 = { class: "con_card sub_page_con_view" }
const _hoisted_6 = ["for"]
const _hoisted_7 = ["id", "onClick"]
const _hoisted_8 = { class: "img_wrap" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  src: "img/no_img1.png",
  alt: ""
}
const _hoisted_11 = { class: "tit_wrap" }
const _hoisted_12 = { class: "elips_2" }
const _hoisted_13 = { class: "tit_date" }
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "onClick"]
const _hoisted_16 = { class: "img_wrap" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "tit_wrap" }
const _hoisted_19 = { class: "elips_2" }
const _hoisted_20 = { class: "tit_date" }
const _hoisted_21 = {
  key: 1,
  class: "tbody_li no_data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("span", null, "Total", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString($setup.state.totalLength), 1)
      ]),
      ($setup.state.hasAuth)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "common_btn _gray",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
            }, "삭제"),
            _createVNode(_component_router_link, {
              class: "common_btn w_130",
              to: { name: 'NewsWrite' }
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("글쓰기", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", null, [
          ($setup.state.list.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.list, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "checkbox_wrap",
                  key: item.idx
                }, [
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("label", {
                          for: item.idx + '',
                          class: "card_tag"
                        }, [
                          ($setup.state.hasAuth)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  name: "chk",
                                  id: item.idx + '',
                                  onClick: ($event: any) => ($setup.selectedIdx(item.idx))
                                }, null, 8, _hoisted_7),
                                _cache[3] || (_cache[3] = _createElementVNode("em", null, null, -1))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_6),
                        _createVNode(_component_router_link, {
                          to: { name: 'NewsView', params: { id: item.idx } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              (item.thumbnail)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.thumbnail,
                                    alt: ""
                                  }, null, 8, _hoisted_9))
                                : (_openBlock(), _createElementBlock("img", _hoisted_10))
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, _toDisplayString(item.title), 1),
                              _createElementVNode("div", _hoisted_13, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("label", {
                          for: item.idx + '',
                          class: "card_tag"
                        }, [
                          ($setup.state.hasAuth)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  name: "chk",
                                  id: item.idx + '',
                                  onClick: ($event: any) => ($setup.selectedIdx(item.idx))
                                }, null, 8, _hoisted_15),
                                _cache[4] || (_cache[4] = _createElementVNode("em", null, null, -1))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_14),
                        _createVNode(_component_router_link, {
                          to: { name: 'NewsView', params: { id: item.idx } }
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_16, [
                              (item.thumbnail)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: item.thumbnail,
                                    alt: ""
                                  }, null, 8, _hoisted_17))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(item.title), 1),
                              _createElementVNode("div", _hoisted_20, _toDisplayString($setup.CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true)), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ], 64))
                ]))
              }), 128))
            : (_openBlock(), _createElementBlock("li", _hoisted_21, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "tr_div" }, [
                  _createElementVNode("div", {
                    class: "tb_subject",
                    style: {"text-align":"center","width":"100%"}
                  }, "등록된 게시물이 없습니다.")
                ], -1)
              ]))]))
        ])
      ]),
      ($setup.state.list.length !== 0)
        ? (_openBlock(), _createBlock(_component_PageBtn, {
            key: 1,
            currentPage: $setup.state.page,
            totalLength: $setup.state.totalLength,
            perPage: $setup.state.size,
            onOnPaging: $setup.handlePageChange
          }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
        : _createCommentVNode("", true)
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true)
  ], 64))
}